import { render, staticRenderFns } from "./ActionPremiumSurveyEnd.vue?vue&type=template&id=6ca5d51a&scoped=true&"
import script from "./ActionPremiumSurveyEnd.vue?vue&type=script&lang=js&"
export * from "./ActionPremiumSurveyEnd.vue?vue&type=script&lang=js&"
import style0 from "./ActionPremiumSurveyEnd.vue?vue&type=style&index=0&id=6ca5d51a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ca5d51a",
  null
  
)

export default component.exports